<template>
    <v-list-item
        @click="onCardClick(appointment)"
        :color="bgColor"
       >

        <template>

          <v-list-item-avatar v-if="appointment.client"  color="secondary" size="30">
            <v-img :src="appointment.client.avatar || getFakeAvatar(appointment.client.gender)"></v-img>
          </v-list-item-avatar>

          <v-list-item-avatar size="30" v-else>
            <v-icon color="secondary" size="30">fas fa-info-circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content class="text-left">

            <v-list-item-title v-if="appointment.client">
              {{`${appointment.client.first_name} ${appointment.client.last_name}`}} <span class="text-caption font-weight-bold">| {{appointment.client.dni | rut}}</span>
            </v-list-item-title>
            <v-list-item-title v-else>Hora cancelada</v-list-item-title>

            <v-list-item-subtitle style="display: flex">
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-icon  size="18" v-on="on">{{appointment.scheduled_from === 'internal' ? 'mdi-desktop-classic': 'mdi-web'}}</v-icon>
                </template>
                {{scheduledFrom}}
              </v-tooltip>

              <event-labels v-if="appointment.labels" :labels="appointment.labels"  dense/>
            </v-list-item-subtitle>


            <v-list-item-subtitle>

              <v-chip :outlined="!isDark" readonly small dark color="black darken-2 ma-1">
                <v-icon size="14" class="mr-2">fas fa-clock</v-icon>
                {{appointment.time}}
              </v-chip>

              <event-status-chip :outlined="!isDark" class="ma-1" v-if="appointment.event_status" :event-status="appointment.event_status" />

              <template v-if="appointment.client">
                <v-chip :outlined="!isDark"  readonly small dark class="ma-1"  color="blue darken-1" v-if="appointment.client.insurance_company">
                  <v-icon size="14" class="mr-2">fas fa-briefcase-medical</v-icon>
                  {{appointment.client.insurance_company.name}}
                </v-chip>

                <v-chip :outlined="!isDark"  readonly small dark  class="ma-1" color="green darken-1">
                  <v-icon size="14" class="mr-2">{{appointment.client.isNew ? 'far fa-file' : 'far fa-file-alt'}}</v-icon>
                  {{appointment.client.isNew ? 'Nuevo' : 'Antiguo'}}
                </v-chip>
              </template>

            </v-list-item-subtitle>
          </v-list-item-content>

        </template>

        <v-list-item-action class="mt-auto">

          <v-btn-toggle>
            <template v-if="appointment.client">

              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn
                      v-on="on"
                      small
                      v-if="appointment.event_status.id < 4"
                      @click.stop="onCancelClick(appointment)"
                  >
                    <v-icon size="18" color="error">mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar cita</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn
                      v-on="on"
                      small
                      @click.stop="onModifyClick(appointment)"
                      v-if="appointment.event_status.id < 3">
                    <v-icon color="secondary">
                      mdi-swap-horizontal
                    </v-icon>
                  </v-btn>
                </template>
                <span>Cambiar cita</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn
                      v-on="on"
                      small
                      @click.stop="onArriveClick(appointment)"
                      v-if="appointment.event_status.id < 3">
                    <v-icon size="20" color="primary">
                      mdi-account-arrow-right-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ingresar {{getLabel('commons.client.singular')}}</span>
              </v-tooltip>
            </template>

            <template v-else>
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-btn
                        v-on="on"
                        small
                        @click.stop="!isPast && onAppointClick(appointment)"
                        v-if="appointment.event_status.id === 6">
                      <v-icon size="18"  color="primary">mdi-account-convert</v-icon>
                    </v-btn>
                  </template>
                  <span>{{isPast ? 'Cita pasada, no es posible reagendar' : 'Citar a otro' + getLabel('commons.client.singular')}}</span>
                </v-tooltip>

              </template>

          </v-btn-toggle>




        </v-list-item-action>


    </v-list-item>
</template>

<script>

    import EventStatusChip from '@/components/appointments/EventStatusChip'

    import {getLabel} from '@/utils/Institution'
    import {getFakeAvatar} from '@/utils/Common'
    import {getStatusColor} from '@/utils/ScheduleEvent'
    import EventLabels from "@/components/appointments/attention/EventLabels";

    export default{
        props: {
          appointment: {
            type: Object,
            required: true
          }
        },
        data(){
            return {
                bgColor: '#f1f1f1',
                dark: false,
            }
        },
        mounted(){
            var vm = this
        },
        components: {EventLabels, EventStatusChip},
        computed: {
            scheduledFrom(){
              const vm = this
              return vm.appointment.scheduled_from === 'internal' ? 'Agendado desde sistema' : `Agendado por ${vm.clientSingular.toLowerCase()}`
            },
            isPast(){
                var vm = this
                return vm.$moment(`${vm.appointment.date} ${vm.appointment.time}`).diff(
                        vm.$moment(),
                        'seconds'
                ) < 0
            },
            statusIcon(){
                switch(this.appointment.event_status.id){
                    case 1:
                        return 'fas fa-info-circle'
                    case 2:
                        return 'fas fa-check-circle'
                    case 3:
                        return 'fas fa-hourglass-half'
                    default:
                        return 'fas fa-check-circle'
                }
            }
        },
        methods: {
            highlight(){
                var vm = this
                vm.bgColor = getStatusColor(vm.appointment.event_status_id)
                vm.dark = true
            },
            unhighlight(){
                var vm = this
                vm.bgColor = '#f1f1f1'
                vm.dark = false
            },
            onCardClick(appointment){
                this.$emit('click:card', appointment)
            },
            onCancelClick(appointment){
                this.$emit('click:cancel', appointment)
            },
            onArriveClick(appointment){
                this.$emit('click:arrive', appointment)
            },
            onModifyClick(appointment){
                this.$emit('click:modify', appointment)
            },
            onAppointClick(appointment){
                this.$emit('click:appointment', appointment)
            },
            getLabel,
            getFakeAvatar,
            getStatusColor
        },
        watch: {
            appointment(val){

                const vm = this

                if(val.highlighted && val.highlighted === true){
                    vm.highlight()
                }else{
                    vm.unhighlight()
                }

            }
        }
    }
</script>

<style scoped>

    .chips-container{
        border: none;
        background-color: transparent !important;
        border-radius: 5px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;
    }

    .labels-container{
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 10px;
      padding-left: 5px;
      background-color: transparent !important;
      justify-content: flex-start;
      align-items: center;
    }

    .label-dot{
      height: 15px;
      width: 15px;
      border-radius: 8px;
      margin: 1px;
    }

    >>>.v-card{
        transition: background-color 1s !important;
       }

    .event-card{
        border: 2px solid !important;
        border-color: rgba(0,0,0,1);
        border-radius: 5px;
        transition: 1s all
    }

</style>
